import { useMemo } from "react";
import CatalogoService from "../services/CatalogoService";
import { useAuth } from "react-oidc-context";
import usePortalAuth from "./usePortalAuth";
import useUrlBasica from "./useUrlBasica";


const useCatalogoService = () => {
    const auth = usePortalAuth();
    const urlBasica = useUrlBasica(); // Chame o hook aqui, no corpo do seu custom hook.

    return useMemo(() => {
        console.log('useCatalogoService re-executado. Solicitando instância para:', auth.isAuthenticated, auth.user?.access_token);
        
        return CatalogoService.getInstance(auth.isAuthenticated, auth.user?.access_token, urlBasica);

    }, [auth.isAuthenticated, auth.user?.access_token, urlBasica]); // Adicione urlBasica às dependências.
}

export default useCatalogoService;